import { ClientRanking } from '../../models/client-ranking';

/**
 * Resultado de um getClientRanking bem-sucedido (sem throw).
 * null da API = vazio — nunca mock silencioso.
 */
export function rankingStateFromApiData(
  data: ClientRanking | null
): { rankingData: ClientRanking | null } {
  if (!data) {
    return { rankingData: null };
  }
  return { rankingData: data };
}
